import { extractYoutubeId } from './youtube';

/**
 * Validates if a string is a properly formatted 11-char YouTube ID.
 */
export const isValidYouTubeId = (id: string | null): boolean => {
  if (!id) return false;
  return /^[a-zA-Z0-9_-]{11}$/.test(id.trim());
};

/**
 * Normalizes and validates if a URL contains a valid YouTube ID.
 */
export const isValidYouTubeUrl = (url: string | null): boolean => {
  if (!url) return false;
  const id = extractYoutubeId(url);
  return isValidYouTubeId(id);
};
